import { SessionTenantInfo } from "@api/core.models";

export abstract class TenantDebtLock {
    abstract enforce(tenantInfo: SessionTenantInfo): void;
}
